import * as MD from '@material-ui/core';
import * as React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import Moment from 'moment';
import { SvgIcon, WithTheme } from '@material-ui/core';

import { IApplicationState, IConnectedReduxProps } from '../../Store';

import { ILayoutState } from '../../Store/Layout/Types';

import { getTheme, PaletteMode } from '../../Themes';

import { I18N, ILocaleInfos } from '../../Store/I18n/Types';

// ICONS
import ClearIcon from '@material-ui/icons/Clear';
import { RadioIcon } from '../../Themes/svg/radio-icon';
import { TvIcon } from '../../Themes/svg/tv-icon';

import {
  ISearchState,
  EMediaTypes,
  ISearchParams,
  IOrderByParams,
  IMusicStateTypes,
  BucketMedia,
} from '../../Store/Search/Types';
import { launchSearch } from '../../Store/Search/Actions';
import { RouterState } from 'connected-react-router';
import { WithStyles } from '@material-ui/styles/withStyles';
import { Calendar } from '../Calendar';
import styles from './Drawer.style';

interface IPropsFromState {
  i18n: I18N;
  layout: ILayoutState;
  localeInfos: ILocaleInfos;
  search: ISearchState;
  router: RouterState;
}

interface IState {
  endDate: Moment.Moment | null | string;
  firstBroadcast: boolean;
  childMediaId: number[] | undefined;
  mediaTypeTV: boolean;
  mediaTypeRadio: boolean;
  orderBy: IOrderByParams[];
  searchInput: string;
  searchAdDataInput: string;
  searchCodeInput: string;
  searchMusicDataInput: string;
  searchMusicState: IMusicStateTypes[] | undefined;
  adType: any;
  isAllChecked: boolean;
  startDate: Moment.Moment | null | string;
  nonValidatedSpots: boolean | undefined;
  items: any[];
  initialSupportId: number[] | null;
  initialSupportGroupId: number[];
  selectedSupportIds: number[];
  selectedSupportGroupIds: number[];
  openSelectSupport: any;
}

interface IPropsFromDispatch {
  launchSearch: typeof launchSearch;
}

type AllProps = WithTheme &
  WithStyles<typeof styles> &
  IPropsFromState &
  IPropsFromDispatch &
  RouteComponentProps<{}> &
  IConnectedReduxProps;

export class DrawerComponent extends React.Component<AllProps, IState> {
  public constructor(props: AllProps) {
    super(props);

    let musicStates = undefined;

    if (this.props.search.params.music_states) {
      musicStates = this.props.search.params.music_states.map(
        (item: any) => IMusicStateTypes[item as any]
      ) as any;
    }

    this.state = {
      endDate: this.props.search.params.end_date,
      firstBroadcast: this.props.search.params.first_broadcast,
      childMediaId: this.props.search.params.child_media_id,
      mediaTypeRadio: this.props.search.params.media === EMediaTypes.RADIO,
      mediaTypeTV: this.props.search.params.media === EMediaTypes.TV,
      orderBy: this.props.search.params.params.order_by,
      searchInput: this.props.search.params.query,
      searchAdDataInput: this.props.search.params.search_ad_data,
      searchCodeInput: this.props.search.params.search_code,
      searchMusicDataInput: this.props.search.params.search_music_data,
      searchMusicState: musicStates,
      adType: null,
      isAllChecked: true,
      startDate: this.props.search.params.start_date,
      nonValidatedSpots: this.props.search.params.non_validated_spots,
      items: [],
      initialSupportId: null,
      selectedSupportIds: [],
      selectedSupportGroupIds: [0, 1, 2],
      initialSupportGroupId: [0, 1, 2],
      openSelectSupport: { 0: false, 1: false, 2: false },
    };
  }

  static getDerivedStateFromProps(props: AllProps, state: IState) {
    if (
      props.search.params.music_states !== undefined &&
      state.searchMusicState === undefined
    ) {
      state.searchMusicState = props.search.params.music_states;
    }
    if (
      props.search.supportType.length > 0 &&
      state.initialSupportId === null
    ) {
      state.initialSupportId = props.search.initialMediaWebId;
      state.selectedSupportIds = props.search.initialMediaWebId;
    }
    return state;
  }

  private saveDates(startDate: any, endDate: any) {
    this.setState({
      startDate: startDate,
      endDate: endDate,
    });
  }

  private drawDatePickerForm() {
    return (
      <MD.FormControl>
        <Calendar saveDates={this.saveDates.bind(this)} />
      </MD.FormControl>
    );
  }

  private handleSearchInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    event.stopPropagation();
    let value = event.target.value;
    if (value.startsWith('\t')) {
      value = value.split('\t')[1];
    }
    this.setState({ [event.target.name]: value as any } as Pick<
      IState,
      keyof IState
    >);
  };

  private onSearchInputKeyDown = (
    event: React.KeyboardEvent<
      HTMLDivElement | HTMLInputElement | HTMLTextAreaElement
    >
  ): void => {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      this.onLaunchSearchClick();
    }
  };

  private handleMediaTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.name === 'tv') {
      this.setState({
        mediaTypeTV: true,
        mediaTypeRadio: false,
      });
    } else if (event.target.name === 'radio') {
      this.setState({
        mediaTypeTV: false,
        mediaTypeRadio: true,
      });
    }
  };

  private drawRadioTVSelect = () => {
    const { classes, layout } = this.props;
    const theme = getTheme(layout.theme);
    let maxWidth = '50%';
    let tvBorder = {
      borderBottom: '2px solid',
      borderBottomColor: '#EEEEEE46',
      maxWidth,
    };
    let radioBorder = {
      borderBottom: '2px solid',
      borderBottomColor: '#EEEEEE46',
      maxWidth,
    };

    if (this.state.mediaTypeTV) {
      tvBorder = {
        borderBottom: '2px solid ',
        borderBottomColor: theme.palette.primary.main,
        maxWidth,
      };
    } else if (this.state.mediaTypeRadio) {
      radioBorder = {
        borderBottom: '2px solid ',
        borderBottomColor: theme.palette.primary.main,
        maxWidth,
      };
    }

    let iconDesactivatedColor = theme.palette.secondary.light + '46';
    if (layout.theme === PaletteMode.DARK) {
      iconDesactivatedColor = theme.palette.secondary.dark + '46';
    }

    return (
      <MD.Grid container justifyContent="space-between" direction="row">
        <MD.Grid item xs={6} style={tvBorder}>
          <MD.FormControlLabel
            style={{
              marginLeft: '16px',
              display: 'flex',
              flexDirection: 'column',
            }}
            classes={{ label: classes.formControlLabel }}
            control={
              <MD.Checkbox
                checked={this.state.mediaTypeTV}
                onChange={this.handleMediaTypeChange}
                icon={
                  <SvgIcon
                    component={TvIcon}
                    className={classes.formControlIcon}
                    htmlColor={iconDesactivatedColor}
                  />
                }
                checkedIcon={
                  <SvgIcon
                    component={TvIcon}
                    className={classes.formControlIcon}
                    htmlColor={theme.palette.primary.main}
                  />
                }
                name="tv"
              />
            }
            label="TV"
          />
        </MD.Grid>
        <MD.Grid item xs={6} style={radioBorder}>
          <MD.FormControlLabel
            style={{
              marginLeft: '16px',
              display: 'flex',
              flexDirection: 'column',
            }}
            classes={{ label: classes.formControlLabel }}
            control={
              <MD.Checkbox
                checked={this.state.mediaTypeRadio}
                onChange={this.handleMediaTypeChange}
                icon={
                  <SvgIcon
                    component={RadioIcon}
                    className={classes.formControlIcon}
                    htmlColor={iconDesactivatedColor}
                  />
                }
                checkedIcon={
                  <SvgIcon
                    component={RadioIcon}
                    className={classes.formControlIcon}
                    htmlColor={theme.palette.primary.main}
                  />
                }
                name="radio"
              />
            }
            label={this.props.i18n._('RADIOS')}
          />
        </MD.Grid>
      </MD.Grid>
    );
  };

  private formatCode(code: string) {
    let sub_code1 = code.substring(0, 4);
    let sub_code2 = code.substring(4, 6);
    let sub_code3 = code.substring(6, code.length);
    let testOK1 =
      sub_code1.length === 4 &&
      parseInt(sub_code1) >= 2000 &&
      parseInt(sub_code1) <= 3000;
    let testOK2 =
      sub_code2.length === 2 &&
      parseInt(sub_code2) >= 1 &&
      parseInt(sub_code2) <= 12;
    let testOK3 = sub_code3.length === 4;
    if (testOK1 && testOK2 && testOK3) {
      code =
        code.substring(0, 4) +
        '.' +
        code.substring(4, 6) +
        '.' +
        code.substring(6, code.length);
    }
    return code;
  }

  private onLaunchSearchClick = () => {
    let types: EMediaTypes = EMediaTypes.TV;
    let bucket_id: any[] = [];
    if (this.state.mediaTypeRadio) {
      types = EMediaTypes.RADIO;
      bucket_id = BucketMedia.FR_RADIO;
    }
    if (this.state.mediaTypeTV) {
      types = EMediaTypes.TV;
      bucket_id = BucketMedia.FR_TV;
    }
    let code = this.state.searchCodeInput;
    code = code.replace('\t', '');
    code = code.replace(/\s/g, '');
    if (code !== '' && code.indexOf('.') < 0) {
      code = this.formatCode(code);
    }
    let startDate = this.state.startDate;
    let endDate = this.state.endDate;

    startDate = Moment(startDate);
    startDate = startDate.format('YYYY-MM-DD') + 'T00:00:00';

    endDate = Moment(endDate);
    endDate = endDate.format('YYYY-MM-DD') + 'T00:00:00';

    let launchRequest: ISearchParams = {
      start_date: startDate as string,
      end_date: endDate as string,
      params: {
        page_size: this.props.search.params.params.page_size,
        page: 1,
        order_by: this.props.search.params.params.order_by,
      },
      query: '',
      search_ad_data: this.state.searchAdDataInput,
      search_code: code,
      search_music_data: this.state.searchMusicDataInput,
      first_broadcast: this.state.firstBroadcast,
      media: types,
      country: this.props.search.params.country,
      bucket_id: bucket_id,
      music_states: [
        IMusicStateTypes.IDENTIFIED,
        IMusicStateTypes.NON_IDENTIFIED,
        IMusicStateTypes.NO_MUSIC,
      ],
      ad_type: this.state.adType,
    };
    if (this.state.searchMusicState) {
      const musicStates = this.state.searchMusicState.map(
        (item: any) => IMusicStateTypes[item as any]
      ) as any;
      launchRequest.music_states = musicStates;
    }
    launchRequest.non_validated_spots = this.state.nonValidatedSpots;
    const locationPathName = this.props.router.location.pathname;

    if (locationPathName !== '/') {
      this.props.history.push('/');
    }

    this.props.launchSearch(launchRequest);
  };

  private onLaunchClearSearchClick = () => {
    let types: EMediaTypes = EMediaTypes.TV;
    let bucket_id: any[] = [];
    if (this.state.mediaTypeRadio) {
      types = EMediaTypes.RADIO;
      bucket_id = BucketMedia.FR_RADIO;
    }
    if (this.state.mediaTypeTV) {
      types = EMediaTypes.TV;
      bucket_id = BucketMedia.FR_TV;
    }
    let code = this.state.searchCodeInput;
    code = code.replace('\t', '');
    code = code.replace(/\s/g, '');
    if (code !== '' && code.indexOf('.') < 0) {
      code = this.formatCode(code);
    }
    let startDate = this.state.startDate;
    let endDate = this.state.endDate;

    startDate = Moment(startDate);
    startDate = startDate.format('YYYY-MM-DD') + 'T00:00:00';

    endDate = Moment(endDate);
    endDate = endDate.format('YYYY-MM-DD') + 'T00:00:00';

    let launchRequest: ISearchParams = {
      start_date: startDate as string,
      end_date: endDate as string,
      params: {
        page_size: this.props.search.params.params.page_size,
        page: 1,
        order_by: [],
      },
      query: '',
      search_ad_data: this.state.searchAdDataInput,
      search_code: code,
      search_music_data: this.state.searchMusicDataInput,
      first_broadcast: this.state.firstBroadcast,
      media: types,
      country: this.props.search.params.country,
      bucket_id: bucket_id,
      music_states: [
        IMusicStateTypes.IDENTIFIED,
        IMusicStateTypes.NON_IDENTIFIED,
        IMusicStateTypes.NO_MUSIC,
      ],
      ad_type: this.state.adType,
    };
    if (this.state.searchMusicState) {
      const musicStates = this.state.searchMusicState.map(
        (item: any) => IMusicStateTypes[item as any]
      ) as any;
      launchRequest.music_states = musicStates;
    }
    launchRequest.non_validated_spots = this.state.nonValidatedSpots;
    const locationPathName = this.props.router.location.pathname;

    if (locationPathName !== '/') {
      this.props.history.push('/');
    }

    this.props.launchSearch(launchRequest);
  };

  private drawFirstBroadcastMediaPlanSelect = () => {
    let mediaPlanOrFirstBroadcast = 'mediaplan';
    if (this.state.firstBroadcast) {
      mediaPlanOrFirstBroadcast = 'firstbroadcast';
    }

    return (
      <MD.FormControlLabel
        control={<MD.Checkbox color="primary" />}
        label={this.props.i18n._('1st broadcast')}
        labelPlacement="end"
        checked={this.state.firstBroadcast}
        onClick={() => {
          if (!this.state.firstBroadcast) {
            this.setState({ firstBroadcast: true });
          } else {
            this.setState({ firstBroadcast: false });
          }
        }}
      />
    );
  };

  public render(): React.ReactNode {
    const { classes } = this.props;

    console.log('rendering component with state', this.state);

    return (
      <MD.Drawer
        anchor="left"
        classes={{
          paper: classes.drawerPaper,
        }}
        open={this.props.layout.showDrawer}
        variant="persistent"
      >
        <MD.Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="stretch"
          spacing={4}
          style={{ marginTop: '16px' }}
        >
          <MD.Grid item xs={12}>
            {this.drawDatePickerForm()}
          </MD.Grid>

          <MD.Grid item xs={12}>
            {this.drawRadioTVSelect()}
            {this.drawFirstBroadcastMediaPlanSelect()}
          </MD.Grid>

          <MD.Grid item xs={12}>
            <MD.Typography variant="subtitle1">
              {this.props.i18n._('Recherche par noms')}
            </MD.Typography>
            <MD.FormControl variant="outlined" fullWidth size={'small'}>
              <MD.OutlinedInput
                name={'searchAdDataInput'}
                id="outlined-adornment-names"
                type="text"
                placeholder={
                  this.props.i18n._('Advertiser') +
                  ' / ' +
                  this.props.i18n._('Product')
                }
                value={this.state.searchAdDataInput}
                onChange={this.handleSearchInputChange}
                onKeyDown={this.onSearchInputKeyDown}
                endAdornment={
                  <MD.InputAdornment position="end">
                    <MD.IconButton
                      aria-label="click to clear the input"
                      onClick={() => {
                        this.setState({ searchAdDataInput: '' });
                      }}
                      edge="end"
                    >
                      <ClearIcon />
                    </MD.IconButton>
                  </MD.InputAdornment>
                }
              />
            </MD.FormControl>
            <MD.Typography variant="subtitle1">
              {this.props.i18n._('Recherche par identifiants')}
            </MD.Typography>
            <MD.FormControl variant="outlined" fullWidth size={'small'}>
              <MD.OutlinedInput
                id="outlined-adornment-identifier"
                name="searchCodeInput"
                type="text"
                placeholder={this.props.i18n._('ID Pub / ID Créa / Code ARPP')}
                value={this.state.searchCodeInput}
                onChange={this.handleSearchInputChange}
                onKeyDown={this.onSearchInputKeyDown}
                endAdornment={
                  <MD.InputAdornment position="end">
                    <MD.IconButton
                      aria-label="click to clear the input"
                      onClick={() => {
                        this.setState({ searchCodeInput: '' });
                      }}
                      edge="end"
                    >
                      <ClearIcon />
                    </MD.IconButton>
                  </MD.InputAdornment>
                }
              />
            </MD.FormControl>
            <MD.Typography variant="subtitle1">
              {this.props.i18n._('Recherche musicales')}
            </MD.Typography>
            <MD.FormControl variant="outlined" fullWidth size={'small'}>
              <MD.OutlinedInput
                name={'searchMusicDataInput'}
                id="outlined-adornment-music"
                type="text"
                placeholder={
                  this.props.i18n._('Author') +
                  ' / ' +
                  this.props.i18n._('Composer') +
                  ' / ' +
                  this.props.i18n._('Title') +
                  ' / ' +
                  this.props.i18n._('ISRC')
                }
                value={this.state.searchMusicDataInput}
                onChange={this.handleSearchInputChange}
                onKeyDown={this.onSearchInputKeyDown}
                endAdornment={
                  <MD.InputAdornment position="end">
                    <MD.IconButton
                      aria-label="click to clear the input"
                      onClick={() => {
                        this.setState({ searchMusicDataInput: '' });
                      }}
                      edge="end"
                    >
                      <ClearIcon />
                    </MD.IconButton>
                  </MD.InputAdornment>
                }
              />
            </MD.FormControl>
          </MD.Grid>

          <MD.Grid item xs={12}>
            <MD.Button
              fullWidth
              color="primary"
              variant="contained"
              onClick={this.onLaunchSearchClick}
              style={{ marginBottom: '8px' }}
            >
              {this.props.i18n._('Rechercher')}
            </MD.Button>
            <MD.Button
              fullWidth
              color="secondary"
              variant="contained"
              onClick={this.onLaunchClearSearchClick}
            >
              {this.props.i18n._('Réinitialiser')}
            </MD.Button>
          </MD.Grid>
        </MD.Grid>
      </MD.Drawer>
    );
  }
}

const mapStateToProps = ({ i18n, layout, search, router }: IApplicationState) => ({
  i18n: i18n.i18n,
  localeInfos: i18n.localeInfos,
  layout,
  search,
  router
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  launchSearch: (searchParams: ISearchParams) => dispatch(launchSearch(searchParams)),
});

export const Drawer =
  connect(mapStateToProps, mapDispatchToProps)(MD.withTheme(MD.withStyles(styles)(DrawerComponent)));
